import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/group.css';
import { SERVICE_TYPE } from '../../../../constants/serviceSubscriptions';
import { IGroup } from '../../../../store';
import { CategoryContainer } from '../Category';
import { GroupHeader } from '../GroupHeader';

interface IGroupProps extends Omit<IGroup, 'categories'>, Pick<Partial<IGroup>, 'categories'> {
  subtitle?: React.ReactNode;
}

export function Group({ title, categories, categoryGroup, subtitle }: IGroupProps) {
  const isService = categoryGroup === SERVICE_TYPE;

  return (
    <div id={`category_${categoryGroup}`} className={cx(isService && styles['container--service'])}>
      <GroupHeader title={title} subtitle={subtitle} />

      {categories && (
        <div className={styles['categories_list']} data-testid="CategoriesList">
          {categories.map(({ categoryType, categoryName, isActive, title: categoryTitle, categoryId, ...rest }) => {
            return (
              <CategoryContainer
                {...rest}
                isActive={isActive}
                title={categoryTitle}
                categoryId={categoryId}
                categoryName={categoryName}
                categoryType={categoryType}
                key={`${categoryName}_${categoryId}`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
